import React from "react";
import { Loading } from "@kitbird/core";
import Modal from "../../../../../components/Modal";
import useCloseReceipt from "../../useCloseReceipt";

interface ModalViewFileProps {
  useCustomHook: ReturnType<typeof useCloseReceipt>;
}

const ModalViewFile = ({ useCustomHook }: ModalViewFileProps) => {
  const {
    isViewFile,
    setViewFile,
    docUrl,
    setDocUrl,
    dataWhiteReceipt,
  } = useCustomHook;

  const fileName = dataWhiteReceipt?.detail_history_closebm.file_receipt?.file_name || "";

  return (
    <Modal
      isOpen={isViewFile}
      setOpen={() => { setViewFile(false); setDocUrl(""); }}
      title={fileName}
      body={<div style={{
        margin: "-16px",
        width: 700,
        height: "70vh",
      }}>
        {docUrl
          ? <div style={{ padding: 16 }}>
            {fileName.split(".").pop()?.toLowerCase().includes("pdf")
              ? <object data={`${docUrl}#toolbar=0&navpanes=0&scrollbar=0&statusbar=0&messages=0&scrollbar=0`} type="application/pdf" width="100%" height="500px">
                <p>Unable to display PDF file. <a href={docUrl}>Download</a> instead.</p>
              </object>
              : <img
                src={docUrl}
                style={{
                  width: 700 - 16 - 16,
                  height: "calc(70vh - 16px - 16px)",
                  objectFit: "contain",
                }}
              />
            }
          </div>
          : <Loading variant="circular" />
        }
      </div>}
      width={700}
    />
  );
};

export default ModalViewFile;
